// styles for the select component that is used for the phases and tasks in the project selection component.
export const delSelect = {
  control: (provided, state) => ({
    ...provided,
    border: "2px solid #000000",
    borderRadius: "4px",
    minHeight: "clamp(32px, 4vh, 40px)",
    height: "clamp(32px, 4vh, 40px)",
    boxSizing: "border-box",
    padding: "0",
    fontSize: "14px",
    backgroundColor: "white",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
    height: "clamp(32px, 4vh, 40px)",
  }),
  input: (base) => ({
    ...base,
    margin: "0",
    padding: "0",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "clamp(32px, 4vh, 40px)",
  }),
  menu: (base) => ({
    ...base,
    minWidth: "100%",
    position: "absolute",
    width: "auto",
    zIndex: 1000,
  }),
  menuList: (base) => ({
    ...base,
    padding: "0",
    backgroundColor: "white",
    "::-webkit-scrollbar": {
      width: "8px",
    },
    "::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "4px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "8px 12px",
    fontSize: "14px",
    backgroundColor: state.isSelected
      ? "#2684FF"
      : state.isFocused
      ? "#F5F5F5"
      : "white",
    color: state.isSelected ? "white" : "black",
    "&:active": {
      backgroundColor: state.isSelected ? "#2684FF" : "#F5F5F5",
    },
  }),
};

// Styles for the select component that is used for the positions in the employee selection component.
export const positionSelectStyles = (hasError = false) => {
  const width = window.innerWidth;
  const desktop = width > 1024;

  return {
    container: (base) => ({
      ...base,
      width: "100%",
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: hasError ? "#dc3545" : provided.borderColor,
      borderWidth: hasError ? "2px" : provided.borderWidth,
      boxShadow: state.isFocused
        ? hasError
          ? "0 0 0 1px #dc3545"
          : "0 0 0 1px #2684ff"
        : provided.boxShadow,
      "&:hover": {
        borderColor: hasError ? "#dc3545" : provided.borderColor,
      },
      minHeight: desktop ? "28px" : "36px",
      height: desktop ? "28px" : "36px",
      boxSizing: "border-box",
      borderRadius: "4px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: desktop ? "28px" : "36px",
      padding: desktop ? "0 4px" : "0 8px",
    }),
    input: (base) => ({
      ...base,
      margin: "0",
      padding: "0",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: desktop ? "28px" : "36px",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      maxHeight: "150px",
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: "150px",
      padding: "0",
      "::-webkit-scrollbar": {
        width: "8px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: hasError ? "#dc3545" : provided.color,
      fontWeight: hasError ? "bold" : provided.fontWeight,
    }),
  };
};

// Styles for the select component that is used for the bill/quantity type select in the misc units table in teh units tab
export const quantityTypeSelectStyles = (hasError = false) => ({
  control: (provided, state) => ({
    ...provided,
    borderColor: hasError ? "#dc3545" : provided.borderColor,
    borderWidth: hasError ? "2px" : provided.borderWidth,
    boxShadow: state.isFocused
      ? hasError
        ? "0 0 0 1px #dc3545"
        : "0 0 0 1px #2684ff"
      : provided.boxShadow,
    "&:hover": {
      borderColor: hasError ? "#dc3545" : provided.borderColor,
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: hasError ? "#dc3545" : provided.color,
    fontWeight: hasError ? "bold" : provided.fontWeight,
  }),
  container: (base) => ({
    ...base,
    width: "100%",
  }),
  valueContainer: (base) => ({
    ...base,
    height: "28px",
    padding: "0 8px",
  }),
  input: (base) => ({
    ...base,
    margin: "0",
    padding: "0",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "28px",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menu: (base) => ({
    ...base,
    maxHeight: "150px",
    zIndex: 9999,
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "150px",
    padding: "0",
    "::-webkit-scrollbar": {
      width: "8px",
    },
    "::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "4px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  }),
});

// Styles for the select component that is used for the JSA supervisor select in the JSA Basic Info tab
export const jsaSupervisorSelectStyles = (hasError = false) => {
  const width = window.innerWidth;
  const desktop = width > 1024;
  const mobile = width < 670;

  return {
    container: (base) => ({
      ...base,
      width: "100%",
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: desktop ? "28px" : "30px",
      height: desktop ? "28px" : "30px",
      boxSizing: "border-box",
      border: hasError ? "2px solid #dc3545" : "1px solid #ddd",
      borderRadius: "4px",
      borderColor: hasError ? "#dc3545" : provided.borderColor,
      borderWidth: hasError ? "2px" : provided.borderWidth,
      boxShadow: state.isFocused
        ? hasError
          ? "0 0 0 1px #dc3545"
          : "0 0 0 1px #2684ff"
        : provided.boxShadow,
      "&:hover": {
        borderColor: hasError ? "#dc3545" : provided.borderColor,
      },
    }),
    valueContainer: (base) => ({
      ...base,
      height: desktop ? "28px" : "30px",
      padding: desktop ? "0 4px" : "0 8px",
    }),
    input: (base) => ({
      ...base,
      margin: "0",
      padding: "0",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: desktop ? "28px" : "30px",
    }),
    menu: (base) => ({
      ...base,
      maxHeight: mobile ? "75px" : "150px",
      zIndex: 1000,
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: mobile ? "75px" : "150px",
      padding: "0",
      "::-webkit-scrollbar": {
        width: "8px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: hasError ? "#dc3545" : provided.color,
      fontWeight: hasError ? "bold" : provided.fontWeight,
    }),
  };
};

// Styles for the select component that is used for the JSA address validation select in the JSA Basic Info tab
export const jsaAddressValidationSelectStyles = () => {
  const width = window.innerWidth;
  const desktop = width > 1024;
  const mobile = width < 670;

  return {
    container: (base) => ({
      ...base,
      width: "100%",
    }),
    control: (base) => ({
      ...base,
      minHeight: desktop ? "28px" : "30px",
      height: desktop ? "28px" : "30px",
      boxSizing: "border-box",
      border: "1px solid #ddd",
      borderRadius: "4px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: desktop ? "28px" : "30px",
      padding: desktop ? "0 4px" : "0 8px",
    }),
    input: (base) => ({
      ...base,
      margin: "0",
      padding: "0",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: desktop ? "28px" : "30px",
    }),
    menu: (base) => ({
      ...base,
      maxHeight: mobile ? "75px" : "150px",
      zIndex: 1000,
      position: "fixed",
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: mobile ? "75px" : "150px",
      padding: "0",
      "::-webkit-scrollbar": {
        width: "8px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
  };
};

export const filterSelectStyles = () => ({
  container: (base) => ({ ...base, width: "100%" }),
  control: (provided) => ({
    ...provided,
    border: "1px solid #ddd",
    borderRadius: "4px",
    minHeight: "clamp(32px, 4vh, 40px)",
    height: "clamp(32px, 4vh, 40px)",
    boxSizing: "border-box",
    padding: 0,
    fontSize: "14px",
    backgroundColor: "white",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
    height: "clamp(32px, 4vh, 40px)",
  }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "clamp(32px, 4vh, 40px)",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 100001 }),
  menu: (base) => ({ ...base, zIndex: 100001, maxHeight: 240, minHeight: 150 }),
  singleValue: (base) => ({
    ...base,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  menuList: (base) => ({
    ...base,
    minHeight: 150,
    maxHeight: 240,
    padding: 0,
    backgroundColor: "white",
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "8px 12px",
    fontSize: "14px",
    backgroundColor: state.isSelected
      ? "#2684FF"
      : state.isFocused
      ? "#F5F5F5"
      : "white",
    color: state.isSelected ? "white" : "black",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
});

export const AdminPageSelectStyles = () => ({
  container: (base) => ({ ...base, width: "100%" }),
  control: (provided) => ({
    ...provided,
    border: "1px solid #ddd",
    borderRadius: "4px",
    minHeight: "clamp(32px, 4vh, 40px)",
    height: "clamp(32px, 4vh, 40px)",
    boxSizing: "border-box",
    padding: 0,
    fontSize: "14px",
    backgroundColor: "white",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
    height: "clamp(32px, 4vh, 40px)",
  }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "clamp(32px, 4vh, 40px)",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 100001 }),
  menu: (base) => ({ ...base, zIndex: 100001, maxHeight: 240, minHeight: 150 }),
  singleValue: (base) => ({
    ...base,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  menuList: (base) => ({
    ...base,
    minHeight: 150,
    maxHeight: 240,
    padding: 0,
    backgroundColor: "white",
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "8px 12px",
    fontSize: "14px",
    backgroundColor: state.isSelected
      ? "#2684FF"
      : state.isFocused
      ? "#F5F5F5"
      : "white",
    color: state.isSelected ? "white" : "black",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
});
